<div class="flex flex-col justify-start items-start">
  <div
    *ngIf="
      item.cells['IsSmartForm'] && item.cells['IsSmartForm'].value === true
    "
    class="smart-form"
  >
    <i class="fa-light fa-location-pin"></i>
    {{ item.cells["IsSmartForm"]?.displayText }}
  </div>
  <div
    *ngIf="item && item.cells"
    class="grid-cell-ellipsis"
    matTooltip="{{
      item.cells[fieldDefinition.key]
        ? item.cells[fieldDefinition.key].value?.toolTip
          ? item.cells[fieldDefinition.key].value?.toolTip
          : item.cells[fieldDefinition.key].displayText
        : ''
    }}"
  >
    {{
      item.cells[fieldDefinition.key]
        ? item.cells[fieldDefinition.key].displayText
        : ""
    }}
  </div>
  <mat-chip-listbox
    class="tag"
    *ngIf="
      item &&
      item.cells &&
      item.cells[fieldDefinition.key] &&
      item.cells[fieldDefinition.key].value &&
      item.cells[fieldDefinition.key].value.length > 0
    "
  >
    <mat-chip *ngFor="let tag of item.cells[fieldDefinition.key].value">
      {{ tag }}
    </mat-chip>
  </mat-chip-listbox>
</div>
